import { render } from "./RUATrigger.vue?vue&type=template&id=9054c09c"
import script from "./RUATrigger.vue?vue&type=script&lang=js"
export * from "./RUATrigger.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__